/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useCallback } from 'react';
import { Button } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { SiteAlert, SiteAlertColors, removeSiteAlert } from '../../../slice/siteAlertsSlice';
import './styles.scss';

const SiteAlerts = () => {

  const siteAlerts = useAppSelector((state) => state.siteAlerts.alerts);

  const dispatch = useAppDispatch();

  const handleRemoveSiteAlert = useCallback((alert: SiteAlert) => {
    dispatch(removeSiteAlert(alert));
  }, [dispatch])

  React.useEffect(() => {
    siteAlerts.forEach(alert => {
      if (alert.timeout && alert.id) {
        setTimeout(() => handleRemoveSiteAlert(alert), alert.timeout);
      }
    });
  }, [siteAlerts, handleRemoveSiteAlert]);

  if (siteAlerts.length === 0) {
    return null;
  }

  return (
    <div className='site-alerts-container'>
      <div className='site-alerts'>
        {siteAlerts.map((alert: SiteAlert) => (
          <div key={`alert-${alert.id}`} className={`site-alert d-flex alert alert-${alert.color ?? SiteAlertColors.Success}`}>
            <div className='flex-fill'>
              {alert.content}
            </div>
            <div>
              <Button color='link' className='p-0' onClick={() => handleRemoveSiteAlert(alert)}>
                <i className='fa fa-times' />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SiteAlerts;
